import React, { useEffect, useState } from 'react';
import { Router, Route, Routes, Navigate } from 'react-router';
import { FieldEditorListFieldsPage } from './pages/FieldEditor-ListFields-Page';
import { GET_CUSTOMFIELD_EDITOR_CONTEXT, CustomfieldEditorContext } from './generated-common';
import { GlobalContextProvider } from './shared-components/common/GlobalContext';
import { FieldEditorListContextsPage } from './pages/FieldEditor-ListContexts-Page';
import { FieldEditorEditOptionsPage } from './pages/FieldEditor-EditOptions-Page';
import { CCLoadingPlaceholder } from 'components/ui/CCLoadingPlaceholder';
import { PageWrapper } from 'shared-components/stateless/layout/PageWrapper';

const App = ({ invoke, view, routerOpen }: { invoke: (key: string, params: any) => Promise<any>; view: any; routerOpen: (uri: string) => Promise<void> }) => {
  const [customfieldEditorContext, setCustomfieldEditorContext] = useState<CustomfieldEditorContext | null>(null);
  const [customfieldEditorContextError, setCustomfieldEditorContextError] = useState<string | null>(null);

  view.theme.enable().then();

  /* REACT ROUTER FORGE SUPPORT START - https://developer.atlassian.com/platform/forge/add-routing-to-a-full-page-app/ */
  const [history, setHistory] = useState<any | null>(null);
  useEffect(() => {
    view.createHistory().then((newHistory: any) => {
      setHistory(newHistory);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [historyState, setHistoryState] = useState<any | null>(null);
  useEffect(() => {
    if (!historyState && history) {
      setHistoryState({
        action: history.action,
        location: history.location,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, historyState]);
  useEffect(() => {
    if (history) {
      history.listen((location: any, action: any) => {
        setHistoryState({
          action,
          location,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
  /* REACT ROUTER FORGE SUPPORT END - https://developer.atlassian.com/platform/forge/add-routing-to-a-full-page-app/ */

  useEffect(() => {
    invoke(GET_CUSTOMFIELD_EDITOR_CONTEXT, {}).then((x: any) => {
      // console.log('FE GET_CUSTOMFIELD_EDITOR_CONTEXT', x);
      if (x.hasError) {
        setCustomfieldEditorContextError(x.statusCode + ' - ' + x.errorMessage);
      } else {
        setCustomfieldEditorContextError(null);
        setCustomfieldEditorContext(x.payload);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {customfieldEditorContextError ? (
        <>FATAL ERROR: {customfieldEditorContextError}</>
      ) : (
        <>
          {customfieldEditorContext != null ? (
            <GlobalContextProvider invoke={invoke} routerOpen={routerOpen} customfieldEditorContext={customfieldEditorContext}>
              {/*<pre>historyState: {JSON.stringify(historyState, null, 2)}</pre>
              <pre>history: {JSON.stringify(history, null, 2)}</pre>*/}
              {history && historyState ? (
                <Router navigator={history} navigationType={historyState.action} location={historyState.location}>
                  <Routes>
                    {/* ============ FIELD EDITOR ============ */}
                    <Route path="/fe/fields/:fieldId/contexts/:contextId" element={<FieldEditorEditOptionsPage />}></Route>
                    <Route path="/fe/fields/:fieldId/contexts" element={<FieldEditorListContextsPage />}></Route>
                    <Route path="/fe/fields" element={<FieldEditorListFieldsPage />}></Route>
                    {/* ============ LANDING PAGE ============ */}
                    <Route path="/" element={<Navigate replace to={'/fe/fields'} />} />
                  </Routes>
                </Router>
              ) : (
                'Loading routes ...'
              )}
            </GlobalContextProvider>
          ) : (
            <PageWrapper>
              <CCLoadingPlaceholder width={290} height={20} />
              <br />
              <CCLoadingPlaceholder width={390} height={40} />
            </PageWrapper>
          )}
        </>
      )}
    </div>
  );
};

export default App;
